// extracted by mini-css-extract-plugin
module.exports = {"bottomSnackbar":"App_bottomSnackbar__2vFMr"};